import React from 'react';
import { IonLabel } from '@ionic/react';

export const ValidatorMessageComponent = ({ message, validationFunction }) => {

    return (
        <>
            {
                validationFunction && validationFunction() &&
                    <IonLabel style={{display:"block"}} color="danger">
                        {message}
                    </IonLabel>
            }
            {
                !validationFunction &&
                    <IonLabel color="danger" style={{display:"block"}}>
                        {message}
                    </IonLabel>
            }
        </>
    )
}
